/**
 * Validates an input to be valid entiyy name
 */
export function jfValidatorPolicyName(XrayNameValidatorDao, $q, $timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function jfValidatorPolicyName(scope, element, attrs, ngModel) {

            let xrayNameValidatorDao = XrayNameValidatorDao.getInstance();
            ngModel.$asyncValidators.name = validateName;

            function validateName(modelValue, viewValue) {


                var value = modelValue || viewValue;

                if (!value) {
                    return $q.when();
                }

                return xrayNameValidatorDao.validatePolicyName({name: value}).$promise
                    .then(function (result) {
                        if (result.exists) {
                            return $q.reject();
                        }
                        return true;
                    });
            }
        }
    };
}


// WEBPACK FOOTER //
// ./modules/xray/directives/validators/jf_validator_policy_name.js